import { TransactionFormField } from "../../components/Transactions/Components/Form/config/config";
import { IAutomationExecutionResult } from "../../config/automation";

export const setBudgetCallback = (payload: any): IAutomationExecutionResult | undefined => {
    const errors = [];
    if (!!payload) {
        if (!payload.budget) {
            errors.push('<budget> property is missing in the payload');
        }
    }

    if (!!errors.length) {
        console.error('setBudgetCallback', errors);
        return;
    }

    return {
        fieldKey: TransactionFormField.BUDGET,
        field: 'budgetId',
        data: payload.budget,
    };
};
